import { vModelText as _vModelText, createVNode as _createVNode, withDirectives as _withDirectives, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1c54eaa4")

_pushScopeId("data-v-1c54eaa4")
const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = { class: "find-input" }
const _hoisted_3 = { class: "natives-list-out" }
const _hoisted_4 = { class: "natives-list" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache) {
  const _component_SidebarItem = _resolveComponent("SidebarItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _withDirectives(_createVNode("input", {
        type: "text",
        placeholder: "Search particles",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.search.value = $event))
      }, null, 512 /* NEED_PATCH */), [
        [_vModelText, _ctx.search.value]
      ]),
      _withDirectives(_createVNode("i", {
        class: "icon-cancel",
        onClick: _cache[2] || (_cache[2] = $event => (_ctx.search.value = null))
      }, null, 512 /* NEED_PATCH */), [
        [_vShow, _ctx.search.value]
      ])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(Object.keys(_ctx.store.state.particles), (dict) => {
          return (_openBlock(), _createBlock(_component_SidebarItem, {
            key: dict,
            name: dict,
            onClick: $event => (_ctx.selectDict(dict)),
            selected: dict == _ctx.selected.value
          }, null, 8 /* PROPS */, ["name", "onClick", "selected"]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
})